import i18n from "i18next";
import { HazardIdEnum, PolicyDetails, LocationRiskAssessment, PageTabs } from "../hazardIdEnum";

import { nasaLandslideColors, nasaPrecipitationColors } from "../../util/colors";
import { PermissionIdEnum } from "../../util/types/permissions/permissionIdEnum";

export const nasaNowcastHazardsList = (): Hazard[] => [
  {
    cysId: HazardIdEnum.NasaCastPrecipitationIta1Day,
    name: "Rain 1 Day (NASA) (ITA)",
    // permissions: ["CYS_NOWC_PRECP_ITA_NASAGPM"],
    permissions: [PermissionIdEnum.NasaCastPrecipitationIta1Day],
    colorRange: nasaPrecipitationColors,
    description: i18n.t("riskExposureMapExplained.precipitationNowcast"),
    label: `${i18n.t("environmentConditions.rainfall")} acc. 1 Day (NASA) (ITA)`,
    pages: [PolicyDetails, LocationRiskAssessment],
    pageTab: PageTabs.warningTab,
  },
  {
    cysId: HazardIdEnum.NasaCastPrecipitationIta3Day,
    name: "Rain 3 Days (NASA) (ITA)",
    // permissions: ["CYS_NOWC_PRECP_ITA_NASAGPM"],
    permissions: [PermissionIdEnum.NasaCastPrecipitationIta3Day],
    colorRange: nasaPrecipitationColors,
    description: i18n.t("riskExposureMapExplained.precipitationNowcast"),
    label: `${i18n.t("environmentConditions.rainfall")} acc. 3 Days (NASA) (ITA)`,
    pages: [PolicyDetails, LocationRiskAssessment],
    pageTab: PageTabs.warningTab,
  },
  {
    cysId: HazardIdEnum.NasaCastPrecipitationIta7Day,
    name: "Rain 7 Days (NASA) (ITA)",
    // permissions: ["CYS_NOWC_PRECP_ITA_NASAGPM"],
    permissions: [PermissionIdEnum.NasaCastPrecipitationIta7Day],
    colorRange: nasaPrecipitationColors,
    description: i18n.t("riskExposureMapExplained.precipitationNowcast"),
    label: `${i18n.t("environmentConditions.rainfall")} acc. 7 Days (NASA) (ITA)`,
    pages: [PolicyDetails, LocationRiskAssessment],
    pageTab: PageTabs.warningTab,
  },

  {
    cysId: HazardIdEnum.NasaCastLandslideIta,
    name: "Landslide (NASA) (ITA)",
    // permissions: ["CYS_NOWC_LSLDE_ITA_NASAGPM"],
    permissions: [PermissionIdEnum.NasaCastLandslideIta],
    colorRange: nasaLandslideColors,
    description: i18n.t("riskExposureMapExplained.landslideNowcast"),
    label: `${i18n.t("riskAssessment.landslideForecast")} (NASA) (ITA)`,
    pages: [PolicyDetails, LocationRiskAssessment],
    pageTab: PageTabs.warningTab,
  },
];
